import { useCallback } from 'react';
import {
  FieldValues,
  SubmitHandler,
  UseFormGetValues,
  UseFormReset,
} from 'react-hook-form';

interface UseResetOnSubmitProps {
  onSubmit: SubmitHandler<FieldValues>;
  getValues: UseFormGetValues<FieldValues>;
  reset: UseFormReset<FieldValues>;
}

/**
 * Wrapper for the onSubmit callback that is passed to the handleSubmit function of react-hook-form.
 * If used the isDirty state of the form is reset whenever the form is submitted. The hook is way
 * more reliable than the effect of the DefaultFormActions component and allows submitting the form
 * multiple times.
 */
export default function useResetOnSubmit({
  onSubmit,
  getValues,
  reset,
}: UseResetOnSubmitProps) {
  const onSubmitWithReset = useCallback<SubmitHandler<FieldValues>>(
    (data, event) => {
      reset(getValues());
      onSubmit(data, event);
    },
    [getValues, onSubmit, reset],
  );

  return {
    onSubmitWithReset,
  };
}
